<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    :submit-button="submitButtonTitle"
    :close-on-submit="false"
    :disable-submit-button="isFileUploading"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :title="title"
    @close="close"
    @submit="save"
  >
    <schema-form
      v-if="show && loadedSchema"
      v-bind="{ ...$attrs, ...$props }"
      :template-name="schemaName"
      :schema="$schema"
    />
  </w-modal>
</template>

<script>
import mixin from '@witkac/bootstrap4-components/src/mixins/formMixin';
import { mapState } from 'vuex';

import SchemaForm from '@/components/forms/SchemaForm';
import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { formRenderContainerMixin } from '@/mixins/formRenderContainer';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Modal formularza generowanego na podstawie schemy
// @group Modals
export default {
  components: { SchemaForm },
  mixins: [mixin, formRenderContainerMixin, modalMixin, notificationsMixin],
  external: {},
  props: {
    // @vuese
    // Dane formularza
    formData: { type: Object, required: false },

    // @vuese
    // Tytuł modala
    title: { type: String, required: false },

    // @vuese
    // External przekazywane do schemy
    external: { type: Object, required: false }
  },
  computed: {
    ...mapState({
      submitButtonSetting(state) {
        return state.setting.settings[PublicSettings.SUBMIT_BUTTON_TEXT];
      },
      isFileUploading(state) {
        return state.media.isUploading;
      }
    }),
    submitButtonTitle() {
      return this.submitButtonSetting ? this.submitButtonSetting.value : 'Wykonaj';
    }
  },
  watch: {
    show() {
      if (this.external) {
        this.$options.external = this.external;
      }
      this.loadSchema();
    }
  },
  methods: {
    // @vuese
    // Zapisuje dane z formularza
    save() {
      if (this.$schema.$validateAll().length) {
        return this.notifyError(Errors.FORM_CORRECT_ERRORS);
      }
      this.$emit('save', this.$schema.$getData());
    },
    // @vuese
    // Ustawia czysty model danych
    setData() {
      if (this.formData && this.$schema) {
        this.$schema.$setData(this.formData, undefined, true);
      }
    }
  }
};
</script>
